import { render } from "./B2bPageOrdersEmits.vue?vue&type=template&id=44bc48da&scoped=true&lang=pug"
import script from "./B2bPageOrdersEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageOrdersEmits.vue?vue&type=script&lang=js"

import "./B2bPageOrdersEmits.vue?vue&type=style&index=0&id=44bc48da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bc48da"]])

export default __exports__